import { SKIP_FORBIDDEN } from './httpConfig';

export class LoanActionApiV2 {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getLoanActions({ includeGlobalEntities } = {}) {
    return this.#http.get('/api/manual-actions', {
      params: { includeGlobalEntities },
    });
  }

  async getLoanActionsByApplicationId({ applicationId }) {
    return this.#http.get(`/api/manual-actions/applications/${applicationId}`);
  }

  async getContactActions({ contactId }) {
    return this.#http.get(`/api/manual-actions/contacts/${contactId}`);
  }

  async executeLoanAction(body) {
    return this.#http.post('api/manual-actions/execute', body);
  }

  async executeStandaloneActions({ applicationId, origin, loanActionTypes, metadata = null }) {
    return this.#http.post(
      'api/manual-actions/execute-standalone',
      { applicationId, origin, loanActionTypes, metadata },
      SKIP_FORBIDDEN,
    );
  }

  async getLoanExport(applicationId) {
    return this.#http.get(`/api/loan-exports/${applicationId}`, { responseType: 'blob' });
  }

  async getLoanExportStatus(applicationId) {
    return this.#http.get(`/api/loan-exports/${applicationId}/status`);
  }

  async executeContactAction({ contactId, loanActionId, metadata = null }) {
    return this.#http.post('api/manual-actions/execute', { contactId, loanActionId, metadata });
  }

  async getSubCompanyActions(subCompanyId) {
    return this.#http.get(`/api/manual-actions/sub-companies/${subCompanyId}`);
  }

  async getSubCompanyActionsBatch({ subCompanyIds }) {
    return this.#http.post('/api/manual-actions/sub-companies/batch', { subCompanyIds });
  }

  async executeSubCompanyAction({ subCompanyId, loanActionId, metadata = null }) {
    return this.#http.post('api/manual-actions/execute', { subCompanyId, loanActionId, metadata });
  }

  async getLoanActionById({ loanActionId }) {
    return this.#http.get(`/api/manual-actions/${loanActionId}`);
  }

  async createLoanAction(body) {
    return this.#http.post('/api/manual-actions', body);
  }

  async editLoanAction(body) {
    return this.#http.put('/api/manual-actions', body);
  }

  async deleteLoanAction({ loanActionId }) {
    return this.#http.delete(`/api/manual-actions/${loanActionId}`);
  }

  async getLoanActionsExpressionDefinition({ targetType } = {}) {
    return this.#http.get('api/expression-definitions/manual-actions', {
      params: { targetType },
    });
  }

  async disableGlobalLoanAction({ id }) {
    return this.#http.post(`/api/manual-actions/${id}/disable`);
  }

  async enableGlobalLoanAction({ id }) {
    return this.#http.post(`/api/manual-actions/${id}/enable`);
  }

  async cloneGlobalLoanAction({ id }) {
    return this.#http.post(`/api/manual-actions/${id}/clone`);
  }
}
